import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Avatar from '../Avatar/Avatar';
import { StyledAppBar, StyledToolBar, AppIconContainer, LeftContent, CenterContent, RightContent, UserContainer, DropDownIconContainer } from './AppBar.styled';
import { jsx as ___EmotionJSX } from "@emotion/core";
const MENU_ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'center'
};
const MENU_TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'center'
};

const AppBar = ({
  appIconUrl,
  onAppIconClick,
  children,
  rightContent,
  user,
  onLogout,
  appName,
  background
}) => {
  const userContainerRef = useRef();
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  const handleLogout = () => {
    setUserMenuOpen(false);
    onLogout();
  };

  const handleUserMenuClick = e => {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      setUserMenuOpen(true);
    }
  };

  const handleAppIconClick = e => {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      onAppIconClick();
    }
  };

  return ___EmotionJSX(StyledAppBar, {
    position: "relative",
    elevation: 0,
    id: "app-bar",
    background: background
  }, ___EmotionJSX(StyledToolBar, null, ___EmotionJSX(LeftContent, null, ___EmotionJSX(AppIconContainer, null, ___EmotionJSX(Avatar, {
    name: appName,
    src: appIconUrl,
    size: "large",
    events: {
      onClick: handleAppIconClick,
      onKeyDown: handleAppIconClick
    },
    attributes: {
      container: {
        role: 'button',
        tabIndex: 0,
        'aria-label': appName
      }
    }
  }))), ___EmotionJSX(CenterContent, {
    "data-testid": "center-content"
  }, children), ___EmotionJSX(RightContent, {
    "data-testid": "right-content"
  }, rightContent, ___EmotionJSX(UserContainer, {
    ref: userContainerRef,
    "data-testid": "user-menu",
    role: "button",
    tabIndex: 0,
    "aria-label": "User menu",
    onClick: handleUserMenuClick,
    onKeyDown: handleUserMenuClick
  }, ___EmotionJSX(Avatar, {
    name: user.fullName,
    src: user.avatar
  }), ___EmotionJSX(DropDownIconContainer, null, ___EmotionJSX(KeyboardArrowDown, null))), ___EmotionJSX(Menu, {
    id: "avatar-menu",
    anchorEl: userContainerRef.current,
    keepMounted: true,
    open: userMenuOpen,
    onClose: () => setUserMenuOpen(false),
    getContentAnchorEl: null,
    anchorOrigin: MENU_ANCHOR_ORIGIN,
    transformOrigin: MENU_TRANSFORM_ORIGIN
  }, ___EmotionJSX(MenuItem, {
    onClick: handleLogout,
    "data-testid": "logout-button"
  }, "Logout")))));
};

AppBar.propTypes = {
  appIconUrl: PropTypes.string.isRequired,
  children: PropTypes.node,
  rightContent: PropTypes.node,
  user: PropTypes.shape({
    fullName: PropTypes.string,
    avatar: PropTypes.string
  }).isRequired,
  onLogout: PropTypes.func.isRequired,
  appName: PropTypes.string.isRequired,
  onAppIconClick: PropTypes.func.isRequired,
  background: PropTypes.string
};
AppBar.defaultProps = {
  rightContent: null,
  children: null,
  background: null
};
export default AppBar;
//# sourceMappingURL=AppBar.js.map